/**
 * <cart-drawer> — open/close chrome only. Its *contents* are owned by
 * cart.js's Section Rendering API refresh (see refreshCartSections), so
 * this element re-queries its close buttons every time it's told to open,
 * since the DOM inside it may have just been replaced.
 */
class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.bindCloseControls();
    document.querySelectorAll('[data-cart-icon]').forEach((link) =>
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      })
    );
    window.NantesPubSub.subscribe(window.NantesEvents.cartUpdate, () => {
      this.bindCloseControls();
    });
  }

  bindCloseControls() {
    this.querySelectorAll('[data-cart-drawer-close]').forEach((el) => {
      el.removeEventListener('click', this._closeHandler);
      this._closeHandler = (event) => {
        if (el.tagName === 'A') return; // let empty-state "continue shopping" navigate too
        event.preventDefault();
        this.close();
      };
      el.addEventListener('click', this._closeHandler);
    });
  }

  open() {
    this.hidden = false;
    document.body.style.overflow = 'hidden';
    const panel = this.querySelector('.cart-drawer__panel');
    requestAnimationFrame(() => {
      window.NantesUtils.trapFocus(panel);
    });
  }

  close() {
    this.hidden = true;
    document.body.style.overflow = '';
    window.NantesUtils.removeTrapFocus();
  }
}

customElements.define('cart-drawer', CartDrawer);

// Open automatically the moment a product is added (product-form.js
// publishes this after a successful /cart/add.js call).
window.NantesPubSub.subscribe(window.NantesEvents.cartUpdate, (cart) => {
  if (!cart || !cart.justAdded) return;
  document.querySelector('cart-drawer')?.open?.();
});
